import AppStatusContainer from 'features/AppStatus';
import React from 'react';

const AppStatusPage = () => <AppStatusContainer />;

export default AppStatusPage;
